/*
 * Block E-Commerce JS Interactions — Info-Only B2B Site
 *
 * Safety net to prevent JS-triggered cart drawers and form submissions
 * that CSS alone cannot block.
 *
 * TO UNDO:
 *   1. Delete this file (assets/custom-hide-ecommerce.js)
 *   2. Remove the <script> tag from layout/theme.liquid
 *      (search for "custom-hide-ecommerce")
 */

(function () {
  'use strict';

  // Block clicks on cart drawer toggle buttons
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest(
      '[data-js-toggle="CartDrawer"], [data-js-toggle="CartUpsellDrawer"]'
    );
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Block form submissions to /cart/* URLs
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.action && form.action.indexOf('/cart') !== -1) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
